export default "__VITE_ASSET__BFaDwHfo__"